/* Offline/SEO fallback data for the dynamic collections and legal documents.
   Bundled at build time (collections.json is generated by scripts/gen-collections.js).
   Used as the INITIAL render state and whenever the API is unreachable, so both the
   prerendered HTML and the live site always show full, crawlable content. */
import {
  Lang, PublicProduct, PublicService, PublicCertification, PublicLocation, PublicFaq,
  LegalKey, LegalDoc,
} from '../types';
import collections from './collections.json';
import legal from './legal.json';

interface CollectionsShape {
  products: PublicProduct[];
  services: PublicService[];
  certifications: PublicCertification[];
  locations: PublicLocation[];
  faq: PublicFaq[];
}

const COLLECTIONS = collections as unknown as Record<Lang, CollectionsShape>;
const LEGAL = legal as unknown as Record<LegalKey, Record<Lang, LegalDoc>>;

function forLang(lang: Lang): CollectionsShape {
  return COLLECTIONS[lang] || COLLECTIONS.de;
}

export const fallbackProducts = (lang: Lang): PublicProduct[] => forLang(lang).products || [];
export const fallbackServices = (lang: Lang): PublicService[] => forLang(lang).services || [];
export const fallbackCertifications = (lang: Lang): PublicCertification[] => forLang(lang).certifications || [];
export const fallbackLocations = (lang: Lang): PublicLocation[] => forLang(lang).locations || [];
export const fallbackFaq = (lang: Lang): PublicFaq[] => forLang(lang).faq || [];

export function fallbackLegal(docKey: LegalKey, lang: Lang): LegalDoc | null {
  const doc = LEGAL[docKey]?.[lang] || LEGAL[docKey]?.de;
  return doc || null;
}
